var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},_vm._l((_vm.labels),function(label,idx){return _c('div',{key:idx,class:_vm.b('label', { [label.size]: true }),style:({ backgroundColor: label.color })},[_vm._v(_vm._s(label.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }